import axios from '../base/axios';
import API_KEY from './key';

const GET_WAR = 'flixfrenzy/redux/GET_WAR';

// eslint-disable-next-line default-param-last
const warReducer = (state = [], action) => {
  switch (action.type) {
    case GET_WAR:
      return action.payload;
    default:
      return state;
  }
};

export const getWar = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=10752`).then((res) => {
    dispatch({
      type: GET_WAR,
      payload: res.data,
    });
  });
};

export default warReducer;
